import React from 'react'
import { accountGroupUsers } from '../../../../service/AccountGroupUsers'
import { useEffect } from 'react'
import SelectInput from '../../../../components/ui/SelectInput'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
export default function PopupGroupUsers({ onClose, dataUser }) {
  const [data, setData] = React.useState([])
  const [dataGroup, setDataGroup] = React.useState([])
  useEffect(() => {
    const fecthData = async () => {
      const res = await accountGroupUsers.getAll()
      if (res.success) {
        setData(res.message.content)
      }
    }
    fecthData()
  }, [])
  const handleClick = async () => {
    const arrayDataUser = []
    for (const [_, value] of dataUser) {
      arrayDataUser.push(value.uuid)
    }
    try {
      for (const group of dataGroup) {
        const resBody = {
          userUuids: [...arrayDataUser],
          groupUuid: group,
        }
        await accountGroupUsers.addListUserToGroup(resBody)
      }
      showSuccessToast('Phân nhóm thành công')
      window.location.reload()
    } catch (err) {
      showErrorToast('Phân nhóm thất bại')
    }
    onClose()
  }
  return (
    <div className="fixed inset-0 flex h-[100%] w-[100%] items-center justify-center bg-opacity-0">
      <div className="z-10 flex h-[50%] w-[38%] flex-col items-center rounded-xl bg-white p-6 shadow-lg">
        <div className="flex h-fit w-[100%] justify-center">
          <p className="mb-2 text-2xl">
            <strong>Phân nhóm tài khoản</strong>
          </p>
        </div>
        <div className="h-full w-[90%]">
          <p className="m-2 items-start p-2 text-2xl">
            <strong>Nhóm người dùng</strong>
          </p>
          <div className="flex h-[60%] w-[100%] flex-col items-center">
            <SelectInput
              defaultValue={''}
              data={data}
              setDataGroup={setDataGroup}
              setData={setData}
            />
          </div>
          <div className="mt-4 flex w-[100%] justify-end gap-10">
            <button
              onClick={onClose}
              className="text-lg font-semibold text-[#DD3500]"
            >
              Hủy
            </button>
            <button
              onClick={handleClick}
              className="rounded-lg border bg-[#909090] p-2 text-lg font-semibold text-[#fff]"
            >
              Xác nhận
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
